import "./style.css";

export default class Share {
  static selector = ".share";

  constructor(block) {
    this.block = block;
    this.button = this.block.querySelector(".share__button");

    this.shareData = this.buildShareData();
    this.isSupported = navigator.share;

    if (this.isSupported) {
      this.block.classList.add("share--supported");
    }
  }

  buildShareData = () => {
    const { title, text, url } = this.block.dataset;

    return {
      title,
      text,
      url,
    };
  };

  // Event handlers
  handleClick = () => {
    navigator
      .share(this.shareData)
      .then(() => console.log("Successful share", this.shareData))
      .catch((error) => console.log("Failed share", this.shareData, error));
  };

  // Lifecycle methods
  onReady() {
    if (this.isSupported) {
      this.button.addEventListener("click", this.handleClick);
    }
  }
  onResize() {}
  onScroll() {}
  onDestroy() {
    if (this.isSupported) {
      this.button.removeEventListener("click", this.handleClick);
    }
  }
}
